import React from 'react';
import PropTypes from 'prop-types';
import { ConfirmFormModal } from './show-confirm-form-modal';
import { AsyncApplyFormModal } from './show-async-apply-form-modal';

export class ApplyFormModal extends React.PureComponent {
  static propTypes = {
    i18n: PropTypes.shape({
      getString: PropTypes.func.isRequired,
    }).isRequired,
    isApplyConfirmModalOpen: PropTypes.bool.isRequired,
    isAsyncApplyModalOpen: PropTypes.bool.isRequired,
    countRecommendation: PropTypes.number.isRequired,
    confirmApplyConfirmModal: PropTypes.func.isRequired,
    rejectApplyConfirmModal: PropTypes.func.isRequired,
    closeAsyncApplyModal: PropTypes.func.isRequired,
    viewHistory: PropTypes.func.isRequired,
  };

  render() {
    const {
      i18n,
      isApplyConfirmModalOpen,
      isAsyncApplyModalOpen,
      countRecommendation,
      confirmApplyConfirmModal,
      rejectApplyConfirmModal,
      closeAsyncApplyModal,
      viewHistory,
    } = this.props;

    return (
      <React.Fragment>
        <ConfirmFormModal
          i18n={i18n}
          isApplyConfirmModalOpen={isApplyConfirmModalOpen}
          countRecommendation={countRecommendation}
          confirmApplyConfirmModal={confirmApplyConfirmModal}
          rejectApplyConfirmModal={rejectApplyConfirmModal}
        />
        <AsyncApplyFormModal
          i18n={i18n}
          viewHistory={viewHistory}
          isAsyncApplyModalOpen={isAsyncApplyModalOpen}
          closeAsyncApplyModal={closeAsyncApplyModal}
        />
      </React.Fragment>
    );
  }
}
